import { findDocNavItem } from '../config/docsNav';
import { parseJobsPortalQuery } from '../config/jobsPortalNav';
import { DOCS_PATH, JOBS_PORTAL_PATH } from '../config/paths';

export const APP_BRAND = 'CronPay';

/** Browser tab title: `CronPay | Dashboard` or `CronPay` when no page name. */
export function formatPageTitle(pageName) {
    const name = String(pageName || '').trim();
    return name ? `${APP_BRAND} | ${name}` : APP_BRAND;
}

function resolveJobsPortalTitle(search) {
    const params = new URLSearchParams(String(search || '').replace(/^\?/, ''));
    const { section, panel, view } = parseJobsPortalQuery(search);

    if (params.get('taskId')) return 'Task';
    if (params.get('employeeId')) return 'Employee';
    if (panel === 'add-employee') return 'Add Employee';
    if (panel === 'dispute') return 'Dispute';

    switch (section) {
        case 'setup':
            if (panel === 'company') return 'Company Profile';
            if (panel === 'employee') return 'Employees';
            return 'Overview';
        case 'create':
            return 'Create Task';
        case 'workspace':
            if (panel === 'activity') return 'Activity';
            if (view === 'disputed') return 'Disputed Tasks';
            if (view === 'assigned') return 'Assigned Tasks';
            if (view === 'company' || view === 'my') return 'Created Tasks';
            return 'Workspace';
        case 'history':
            return 'Task History';
        case 'earnings':
            return 'Earnings';
        case 'profile':
            return 'Profile';
        case 'stats':
            return 'Stats';
        default:
            return 'Company & Jobs';
    }
}

function resolveDocsTitle(pathname) {
    if (pathname === DOCS_PATH) {
        return 'Documentation';
    }
    const prefix = `${DOCS_PATH}/`;
    if (!pathname.startsWith(prefix)) {
        return 'Documentation';
    }
    const slug = pathname.slice(prefix.length).split('/')[0];
    const item = findDocNavItem(slug);
    return item?.label || 'Documentation';
}

const STATIC_ROUTE_TITLES = {
    '/': 'Home',
    '/dashboard': 'Dashboard',
    '/pay': 'Pay',
    '/get-paid': 'Get Paid',
    '/on-going': 'Ongoing',
    '/dispute': 'Disputes',
    '/dispute/report-problem': 'Report Problem',
    '/create-account': 'Create Account',
    '/admin-dashboard': 'Admin Dashboard',
    '/admin-contract-analytics': 'Contract Analytics',
    '/admin-dispute': 'Admin Disputes',
    '/company-job': 'Company & Jobs',
};

export function resolvePageTitle(pathname, search = '') {
    if (/^\/admin-dispute\/[^/]+$/.test(pathname)) {
        return 'Dispute Details';
    }

    if (pathname === JOBS_PORTAL_PATH || pathname.startsWith(`${JOBS_PORTAL_PATH}/`)) {
        return resolveJobsPortalTitle(search);
    }

    if (pathname === DOCS_PATH || pathname.startsWith(`${DOCS_PATH}/`)) {
        return resolveDocsTitle(pathname);
    }

    return STATIC_ROUTE_TITLES[pathname] || null;
}

export function getDocumentTitle(pathname, search = '') {
    return formatPageTitle(resolvePageTitle(pathname, search));
}
